export type GroupingConfig = {
  groupByFromSettings: string[];
  valuesFromSettings: string[];
  percentileDistribution?: boolean;
};

export const chartGroupingConfig: Record<string, GroupingConfig> = {
  stackedBarChart: {
    groupByFromSettings: ["decompositionMetric", "decompositionMetricSecondary"],
    valuesFromSettings: ["displayMetric"],
  },
  doughnutChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  pieChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  comboColumnLineChart: {
    groupByFromSettings: ["xAxis"],
    valuesFromSettings: ["yAxisPrimary", "yAxisSecondary"],
  },
  stackedBar100Chart: {
    groupByFromSettings: ["decompositionMetric", "decompositionMetricSecondary"],
    valuesFromSettings: ["displayMetric"],
  },
  stackedColumn100Chart: {
    groupByFromSettings: ["decompositionMetric", "decompositionMetricSecondary"],
    valuesFromSettings: ["displayMetric"],
  },
  barChart: {
    groupByFromSettings: ["yAxis"],
    valuesFromSettings: ["xAxisPrimary"],
  },
  boxPlot: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
    percentileDistribution: true,
  },
  boxPlotHorizontal: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
    percentileDistribution: true,
  },
  bubbleChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric", "xAxis", "yAxis"],
  },
  bulletChart: {
    groupByFromSettings: ["yAxis"],
    valuesFromSettings: ["yAxis"],
  },
  columnChart: {
    groupByFromSettings: ["xAxis"],
    valuesFromSettings: ["yAxisPrimary"],
  },
  waffleChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  treeMap: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  stackedColumnChart: {
    groupByFromSettings: ["decompositionMetric", "decompositionMetricSecondary"],
    valuesFromSettings: ["displayMetric"],
  },
  scatterPlot: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["xAxis", "yAxis"],
  },
  packedCircleChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  nestedDoughnutChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric", "displayMetricSecondary"],
  },
  lollipopChart: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
  },
  heatMap: {
    groupByFromSettings: ["decompositionMetric", "decompositionMetricSecondary"],
    valuesFromSettings: ["displayMetric"],
  },
  groupedBarChart: {
    groupByFromSettings: ["yAxis"],
    valuesFromSettings: ["xAxisPrimary", "xAxisSecondary"],
  },
  groupedColumnChart: {
    groupByFromSettings: ["xAxis"],
    valuesFromSettings: ["yAxisPrimary", "yAxisSecondary"],
  },
  funnelChart: {
    groupByFromSettings: [],
    valuesFromSettings: ["stage1Metric", "stage2Metric", "stage3Metric", "stage4Metric", "stage5Metric"],
  },
  dumbbellPlotHorizontal: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
    percentileDistribution: true,
  },
  dumbbellPlot: {
    groupByFromSettings: ["decompositionMetric"],
    valuesFromSettings: ["displayMetric"],
    percentileDistribution: true,
  },
  comboBarLineChart: {
    groupByFromSettings: ["yAxis"],
    valuesFromSettings: ["xAxisPrimary", "xAxisSecondary"],
  },
};
